import Card from "./Card";
import { gradesData } from "@/utils/constants";

function Classes() {
    return (
        <section className="relative py-20 space-y-20">
            <div className="relative">
                <img
                    src="/images/home/about/outline.webp"
                    className="absolute hidden object-fill xl:block xl:-top-10"
                    alt=""
                />
                <header className="py-3 text-center">
                    <h2 className="mb-4 text-2xl md:text-3xl text-primary-color-primary">
                        الصفوف{" "}
                        <span className="text-text-color-primary">
                            الدراســـــــــــــــــية
                        </span>
                    </h2>
                </header>

                <div className="container flex flex-wrap items-center justify-center gap-8 mx-auto">
                    {gradesData.map((item, index) => (
                        <Card key={index}
                            title={item.attributes?.description}
                            link={`${item.attributes?.school_level}/${item.attributes?.grade}/courses`}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Classes;
